import { useEffect, useRef, useState } from 'react';

/** 由真实用户动作锁住按钮直到异步流程结束，失败提示保持在当前操作旁。 */
export function useCardAction(action?: () => Promise<void>) {
  const locked = useRef(false);
  const mounted = useRef(true);
  const [pending, setPending] = useState(false);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  /** ref 同步加锁，覆盖 React 尚未提交 disabled 属性时的连续激活。 */
  const run = async () => {
    if (!action || locked.current) return;
    locked.current = true;
    setPending(true);
    setFailed(false);
    try {
      await action();
    } catch {
      if (mounted.current) setFailed(true);
    } finally {
      locked.current = false;
      if (mounted.current) setPending(false);
    }
  };
  return { pending, failed, run };
}
